<template>
  <div class="index">
    <vuescroll :ops='vuescrollOption'>
      <div class='banner'>
        <img src="@/assets/images/index/bannerBg.jpg" class="bg">
        <div class='downloadBT'>
          <img src="@/assets/images/index/googleBT.png" @click='tipsText="敬請期待"' class="googleBT">
          <img src="@/assets/images/index/iphoneBT.png" @click='tipsText="敬請期待"' class="iphoneBT">
        </div>
      </div>
      <div class="content">
        <div class='breadcrumb'>
          <div class="left">
            您目前的位置：<router-link to="/index">首頁</router-link>> 手機遊戲服務使用者合約書
          </div>
          <div class="right">
            <router-link to="/index">
              <img src="@/assets/images/article/returnHome.png">
            </router-link>
          </div>
        </div>
        <div class='titleDiv'>
          <div class="title">
            手機遊戲服務使用者合約書
          </div>
          <div class="time">
            2021-09-01 18:00:13
          </div>
        </div>
        <div class='contentText'>
          <div>立約宗旨：</div>
          <div>立本約旨在明定使用者，在進行本手機遊戲時，應享之權利與應盡之義務，亦同時記載本遊戲所屬公司，應該擔負之各項責任，請務必詳讀本約之內容，以保障您個人權益。一旦您按下「同意」鍵後，即表示您同意並且願意，在使用本公司所作各類服務時，恪遵本約之諸項規定，如有違法願負相關法律責任。如您無法接受本約內容，請您按下「不同意」鍵離開遊戲。</div>
          <div>如您是未滿二十歲之無行為能力或限制行為能力人，則您必須在加入會員前，請您的父母或監護人閱讀本合約書，並得到其同意，才可註冊及使用本方所提供之會員服務；一旦您完成註冊並開始使用本方所提供之服務，即推定您的父母、監護人或法定代理人已經閱讀，並了解與同意本方之各會員服務條款。</div>
          <div>當您開始使用由本公司所提供之【仕治整合官網】平台遊戲服務或其他加值等服務（以下統稱「本服務」）時，即表示您已審閱本合約超過三日，並同意遵守本合約、【仕治整合官網】平台下各遊戲管理規範、【仕治整合官網】網站所公告之所有注意事項及中華民國法律之規定。</div>
          <div>立合約書人：</div>
          <div>本服務使用人：　　　　　　 （以下簡稱「甲方」）</div>
          <div>未成年法定代理人：</div>
          <div>電    話：</div>
          <div>居 住 所：</div>
          <div>仕治整合股份有限公司 （以下簡稱「乙方」）</div>
          <div>代 表 人：楊繼華</div>
          <div>網    址：http://www.digivision.com.tw</div>
          <div>統一編號：16176905</div>
          <div>一、	合約之內容：</div>
          <div>以下視為本合約之一部分，與本合約具有相同之效力：</div>
          <div>(1)	乙方有關本服務之廣告、公告、活動規定或宣傳內容。 </div>
          <div>(2)	費率表、各遊戲服務合約及遊戲管理規範。</div>
          <div>前項合約內容相互間有衝突者，應為消費者有利之解釋。</div>
          <div>二、	名詞定義：</div>
          <div>以下之名詞定義適用於本使用者合約、各遊戲服務合約及遊戲管理規範：</div>
          <div>(1)	遊戲網站：係指由乙方為提供本服務所建置之網站。</div>
          <div>(2)	儲值：係指甲方給付乙方之金額後，兌換為遊戲網站之點數，甲方得再以點數使用本服務。 </div>
          <div>(3)	手機遊戲：係指甲方以其電腦設備透過網際網路連線，經由乙方所架設之網站平台旗下各遊戲或本服務程式，使甲方得與不特定之多數人同時連線，進行遊戲之軟體。 </div>
          <div>(4)	程式漏洞(BUG)：非乙方設計本服務程式時所預見或規劃之遊戲呈現方式、操作模式或所表現之遊戲結果。 </div>
          <div>(5)	外掛程式：係指除乙方提供之手機遊戲程式與甲方電腦設備之作業系統程式、輔助作業系統運作之相關程式、連接網際網路所需之必要程式外，非乙方所提供用以影響乙方手機遊戲程式運作或影響封包傳輸之程式。 </div>
          <div>(6)	遊戲管理員（簡稱GM）：由乙方所聘僱，擔任維護本服務進行之順暢、公平與提供本服務操作問題解答或其他客戶服務相關事項之人員。 </div>
          <div>(7)	遊戲歷程：係指自甲方登入遊戲網站使用本服務起，至登出遊戲網站止，遊戲網站電腦系統對甲方使用本服務過程所為之記錄。 </div>
          <div>(8)	禁言處分：係指暫停甲方於遊戲網站一定時間內輸入文字顯示之權利。</div>
          <div>(9)	角色停權：係指暫停甲方使用於遊戲網站中自行設定之角色人物。</div>
          <div>(10)	暱稱：係指甲方於遊戲網站中自行設定的虛擬角色的名字。 </div>
          <div>(11)	遊戲管理規範/服務合約：係指由乙方訂立，供作規範各遊戲或各代理遊戲進行方式之規則，且構成甲、乙雙方合約之一部分，與本合約具有相同效力。</div>
          <div>(12)	遊戲套件：係指具備主、副程式，且能完整執行手機遊戲全部功能之軟體。 </div>
          <div>(13)	必要成本：係指甲方進行本遊戲期間之乙方最低遊戲營運成本，包括倉儲、貨運、上下架、代銷抽成等通路成本，及設計、製造、包裝與服務遊戲點卡產生之直接成本。 </div>
          <div>三、	本服務範圍：</div>
          <div>本合約所提供之本服務，係由乙方提供遊戲網站，讓甲方透過網際網路連線登入進行手機遊戲。但不包括甲方向網際網路接取服務業者申請接取網際網路之服務及提供上網所需之各項硬體設備。</div>
          <div>四、	個人資料之提供：</div>
          <div>甲方申請使用本服務，應於遊戲網站登錄完整、詳實、真實且為符合身分證明文件之個人資料，甲方所登錄之資料有錯誤或已變更時，應隨時向乙方申請更正之。(請注意保管個人帳號、密碼及身分證字號等資料，為維護自己權益，切勿使用他人身分證字號等資料申請，如有違反之情事，乙方有權暫停甲方使用本服務。) </div>
          <div>如甲方疏漏未提供真實完整之資料，或原登錄之資料已不符合真實而未更新，乙方得於甲方提供真實且完整之資料前，乙方得暫停甲方使用本服務、遊戲歷程查詢、其他與本服務相關之服務，以及帳號內未使用的點數。</div>
          <div>若甲方使用虛假、錯誤或不正當之方式進行「儲值」，乙方得取消、暫停或終止甲方會員資格、各項會員服務之權利及本合約。</div>
          <div>如甲方申請使用【仕治整合官網】網站所提供之代理遊戲服務者，即視為甲方同意乙方得將其所提供之個人資料轉交予代理遊戲之授權人（即與乙方簽署代理遊戲之代理合約之第三人），惟乙方應告知代理遊戲之授權人不得違法或於為甲方使用代理遊戲服務之範圍外，使用、洩露或交付甲方個人資料予其他人。</div>
          <div>(使用手機遊戲，請甲方小心個人資料勿外洩、注意網路交友及遊戲詐騙事件（如虛擬寶物或遊戲帳號交易等）)。</div>
          <div>五、	帳號與密碼之使用：</div>
          <div>甲方於本服務註冊程序中應自行設定一組帳號及密碼，經乙方遊戲網站核對確認後即設定該組帳號及密碼予甲方使用，該組帳號一經設定即不得變更，且僅供甲方使用，甲方不得將該組帳號、密碼轉讓、交付、揭露或出借予第三人，如因而產生糾紛，由甲方自行負責。 </div>
          <div>甲方取得之密碼需於乙方提供之修改機制進行變更。 </div>
          <div>甲方就本條之帳號及密碼的保管負全責，如因保管不周致帳號、密碼遭他人非法使用，此屬可歸責於甲方之情形，亦由甲方自行負責。</div>
          <div>(請注意，保護帳號的安全性是自身的責任，若甲方的帳號或電腦因病毒、利用任何非乙方之連結方式進行本遊戲所造成的結果，因而造成被盜取帳號之類似情事，乙方將不承擔任何損失。)</div>
          <div>六、	帳號密碼遭非法使用之通知： </div>
          <div>任一方發現第三人非法使用甲方之帳號，或有使用安全遭異常破壞之情形時，應立即通知對方。甲方接獲乙方通知，或甲方通知乙方後，經雙方確認有前述情事者，乙方應立即暫停該組帳號或密碼之使用權限，並更換新帳號或密碼予甲方。 </div>
          <div>前項情形者，不得將乙方所採取之措施解釋為乙方對您有明示或默示擔保或賠償責任，乙方應返還甲方其已被遊戲網站系統扣除之儲值或補償相當於被遊戲網站系統所扣除之儲值價值之費用，但可歸責於甲方者，不在此限。</div>
          <div>七、	電磁紀錄被不當移轉時之處理方式：</div>
          <div>甲方如發現帳號、密碼被非法使用，且遊戲電磁紀錄遭不當移轉時，應立即通知乙方查證，經乙方查證甲方之個人身分無誤及以檢視IP位址是否為甲方未曾使用過之位址方式查證確認後，應立即暫時凍結該組帳號、其他可疑帳號及持有遭不當移轉電磁紀錄之帳號，並暫時限制相關手機遊戲使用人就本服務之使用權利。 </div>
          <div>乙方應於暫時限制遊戲使用權利之時起，即刻以書面或電子郵件通知持有前項電磁紀錄之第三人提出說明。如該第三人未於接獲通知時起七日內提出說明，乙方應直接回復遭第三人不當移轉之電磁紀錄予甲方，如不能回復者時可採其他雙方同意之相當補償方式，並於回復後解除對相關手機遊戲使用人之限制。(請注意：該第三人應負其所有法律責任，乙方得暫停該第三人之權利以進行配合司法調查，本公司僅協助甲方相關電磁紀錄移轉之調查，不負任何損害或補償之義務。)</div>
          <div>持有第一項電磁紀錄之第三人不同意乙方前項之處理，乙方得依報案程序，循司法途徑處理。</div>
          <div>乙方依第一項規定限制甲方之使用權時，在限制使用期間內，乙方不得向甲方收取費用。 </div>
          <div>甲方如有申告不實之情形致生乙方或其他手機遊戲使用人權利受損時，應負一切法律責任。</div>
          <div>八、	會員資料處理：</div>
          <div>對於甲方所登錄或留存之個人資料，甲方同意乙方得於合理之範圍內保存、蒐集、處理、傳遞及使用甲方個人資料或其衍生之相關電磁錄，以提供甲方其他資訊服務，或作成會員統計資料、進行關於網路行為之調查或研究或為任何之合法使用。 對於甲方所登錄或留存之個人資料，乙方在未獲甲方同意之前，不對外揭露甲方之姓名、地址、電子郵件地址及其他依法受保護之個人資料，但下列情況不在此限：</div>
          <div>(1)	受司法、警察或其他有權機關基於法定程序之要求時。 </div>
          <div>(2)	於維護公益或保護乙方或他人權益時。 </div>
          <div>(3)	因甲方之行為違反法令或本服務條款之規定時。</div>
          <div>(4)	在緊急情況下為維護其他會員或第三人之人身、交易內容、遊戲歷程、個人資料之完整安全時。</div>
          <div>九、	本服務應載明之資訊：</div>
          <div>乙方應於遊戲網站及遊戲套件包裝上載明以下事項：</div>
          <div>(1)	依電腦軟體分級辦法規定標示遊戲分級級別及禁止或適用使用之年齡層。</div>
          <div>(2)	使用本服務之最低軟硬體需求。 </div>
          <div>(3)	第十條第一項所列之退費權利。</div>
          <div>(4)	有提供安全裝置者，其免費或付費資訊。</div>
          <div>十、	遊戲套件與軟體之退費：</div>
          <div>甲方得於購買本服務遊戲套件或付費下載本服務相關軟體後七日內，向原購買處業者，請求全額退費。但已於遊戲中使用之遊戲套件或軟體者，不在此限，若已於遊戲中使用之遊戲套件或軟體者，並甲方向購買處業者強行進行退費時，則視同甲方放棄遊戲帳號權利，乙方得凍結甲方之退費帳號。</div>
          <div>十一、遊戲歷程之保存期限、查詢方式及費用：</div>
          <div>乙方應保存甲方之個人遊戲歷程記錄，且保存期間為三十日，以供甲方查詢。如逾電磁紀錄保存期限三十天者，恕乙方無法受理甲方之查詢申請。</div>
          <div>甲方得以書面、網路，或親至乙方之客服中心申請調閱甲方之個人遊戲歷程或因誤植而更正會員資料等之相關會員服務申請，且須提出與身份証明文件相符之個人資料以供查驗，查詢費用為新台幣貳佰元，由甲方負擔。</div>
          <div>乙方接獲甲方之查詢申請，應提供第一項所列之甲方個人遊戲歷程，並於七日內以光碟或磁片等儲存媒介或書面、電子郵件方式提供資料。</div>
          <div>十二、本服務之暫停服務與更改：</div>
          <div>於發生下列情形之一時，乙方得停止或中斷提供服務，且不負任何責任：</div>
          <div>(1)	發生突發性之軟硬體設備與電子通信或網站營運設備故障時。 </div>
          <div>(2)	任何不可歸責於乙方之因致遊戲網站無法正常營運，而無法提供本服務時。 </div>
          <div>(3)	乙方對於遊戲網站、本服務程式或各手機遊戲等軟硬體設備進行定期性或例行性維護。 </div>
          <div>(4)	因天災等不可抗力之因素致使本服務無法提供服務時。</div>
          <div>(5)	在緊急情況下為維護其他會員或第三人的人身、資料之完整安全。</div>
          <div>甲方應瞭解並同意，遊戲網站或本服務程式可能因乙方、其他協力廠商或相關電信業者網路系統軟硬體設備之故障或失靈、阻礙而全部或一部中斷、暫時無法使用、遲延、或造成資料傳輸或儲存上之錯誤、或遭第三人侵入系統篡改或偽造變造資料等。</div>
          <div>十三、連線品質：</div>
          <div>乙方各項系統設備因預先計畫所需之系統維護停機，應於七日前於遊戲網站中公告，且於甲方登入時通知，並於遊戲進行中發佈停機訊息。 </div>
          <div>乙方應確保其系統設備，無發生錯誤、畫面暫停、遲滯、中斷或不能進行連線的情形。如因可歸責於乙方之事由致不能提供甲方服務時，乙方應返還甲方已被扣除之儲值，或免收相當之遊戲費用，或遞延甲方得使用本服務之時間。</div>
          <div>乙方係屬網路服務內容提供廠商而非ISP業者，若因ISP網路線路的品質不良或非可歸責於乙方之原因，造成遊戲進行中產生LAG或進度回溯的情形，而造成甲方的損失，乙方將不負賠償責任。</div>
          <div>十四、系統安全、程式漏洞：</div>
          <div>乙方應依本合約之規定負有於提供本服務時，維護其自身電腦系統，符合當時科技或專業水準可合理期待之安全性。 </div>
          <div>電腦系統或電磁紀錄受到破壞，或電腦系統運作異常時（如乙方伺服器超載致有電磁記錄無法寫入或相類似情況發生），乙方應採取合理之措施後儘速予以回復（如重開伺服器，將遊戲回復至未超載前之狀態）。</div>
          <div>乙方違反前二項規定，致生甲方損害時，應依甲方之受損害情形，負損害賠償責任，但乙方能證明其無過失時，得減輕其賠償責任。 </div>
          <div>乙方電腦系統發生第二項所稱情況時，於完成修復並正常運作之前，乙方不得向甲方收取費用。 </div>
          <div>因本服務程式漏洞致甲方受損時，乙方應依甲方之受損害情形，負損害賠償責任。但乙方能證明其無過失者，得減輕其賠償責任。</div>
          <div>當本服務因硬體設備變更、調整或使用者人數增加時，甲方同意乙方可以將您使用的帳號及遊戲記錄轉移或複製至其他位置，乙方也承諾願意配合進行相關設定以因應此類調整。</div>
          <div>十五、風險承擔：</div>
          <div>甲方同意使用本服務係基於甲方的個人意願，並同意自負風險，包括因為自遊戲網站下載資料或圖片，或自本服務中獲得之資料導致甲方的電腦系統損壞，或是發生任何資料流失等結果。</div>
          <div>十六、智慧財產權：</div>
          <div>遊戲網站上之所有著作及資料（包含但不限於虛擬商品、寶物、虛擬金幣等電磁記錄），其著作權、專利權、商標、營業秘密、其他智慧財產權、所有權或其他權利，均為乙方或其權利人所有，除事先經乙方或其權利人之合法授權外，甲方不得擅自重製、傳輸、改作、編輯或以其他任何形式、基於任何目的加以使用，否則應負所有法律責任。</div>
          <div>前項情形，甲方亦不得對於因持有或占有乙方遊戲網站上之所有著作及資料而為移轉、買賣、讓與或其他處分之行為。</div>
          <div>十七、申訴權利：</div>
          <div>甲方不滿意乙方提供之連線品質、遊戲管理、費用計費、其他相關之服務品質，或對乙方依遊戲管理規則之處置不服時，得於收到通知之翌日起七日內至乙方之服務中心或以電子郵件或書面提出申訴，乙方應於接獲申訴後，於十五日內回覆處理之結果。</div>
          <div>乙方應於遊戲網站、遊戲管理規則或服務合約中明訂二十四小時服務專線、申訴服務專線與電子郵件位址。</div>
          <div>十八、遵守中華民國法令：</div>
          <div>甲方應遵守所有與登入遊戲網站及使用本服務相關之中華民國法令。</div>
          <div>若甲方的行為違反本合約或法令規定，乙方得暫停甲方帳號使用權、停止提供本服務，並依第十五條終止合約規定終止本合約，甲方違反法律規定之情事，應自負法律責任。</div>
          <div>甲方承諾遵守中華民國相關法規及一切國際網際網路規定與慣例。若使用遊戲網站台灣地區以外之網站，同意遵守各該網站當地之法令及網路慣例；本公司僅提供台灣地區（包含台、澎、金馬等地區）之會員服務。</div>
          <div>甲方同意並保證不公布或傳送任何毀謗、不實、威脅、不雅、猥褻、不法、攻擊性、毀謗性或侵害他人智慧財產權的文字，圖片或任何形式的檔案於遊戲網站上。 </div>
          <div>甲方保證不會於遊戲網站或本服務從事廣告或販賣商品或虛擬商品、寶物、虛擬金幣等之行為。 </div>
          <div>甲方保證不會於現實世界中交易本服務所提供之任何內容(包括且不限於帳號、虛擬物品、虛擬貨幣、電磁記錄等)，一經查證屬實，乙方得立即暫停甲方使用繼續本服務之權利，且依第十五條終止合約規定終止本合約。若因前述行為招致其他法律糾紛，乙方概不負責。</div>
          <div>甲方同意避免在公眾討論區討論私人事務，發表文章時，應尊重他人的隱私權及其他合法權益。</div>
          <div>甲方同意必須充份尊重智慧財產權，禁止發表侵害他人各項智慧財產權之文 字、圖片或任何形式的檔案。</div>
          <div>甲方同意乙方擁有一切有關本手機遊戲之智慧財產權，以及其他相關服務之所有權利。未經合法授權者，不得予以出租、轉售或從事其他營利行為，更不得對本手機遊戲進行複製 (copy)、散佈 (distribute)、修改、解碼 (Decompile)、還原工程 (Reverse Engineering)、反向組譯 (Disassemble)，或任何更動、破壞等行為，如甲方有違法之情事發生，須負相關法律責任。</div>
          <div>十九、刪除過期帳號： </div>
          <div>甲方帳號超過一年(含)未登入遊戲網站並使用本服務者，乙方得於通知後30日內刪除該帳號，並回收相關虛擬遊戲套件。 </div>
          <div>本服務各手機遊戲公告停止營運滿30天，甲方仍未辦理相關補償程序，視同甲方同意依乙方所公告之處理辦法履行，絕無異議。 </div>
          <div>乙方實施本條各項刪除帳號行為前，均將在遊戲網站各遊戲網頁公告及電子郵件通知30天後實施。</div>
          <div>二十、計費標準：</div>
          <div>費率如有調整時，應自調整生效日起按新費率計收；若新費率高於舊費率時，甲方在新費率生效日前已於遊戲網站中登錄之儲值應依舊費率計收。 </div>
          <div>費率調整時乙方應於調整生效日起三十日前，於遊戲網站、各手機遊戲網站、遊戲進行中或遊戲起始畫面公告，並以電子郵件通知甲方。</div>
          <div>二十一、電磁記錄 ： </div>
          <div>本服務之所有電磁記錄均屬乙方所有，乙方並應維持甲方相關電磁記錄之完整，甲方僅取得該電磁記錄之使用支配權。 </div>
          <div>二十二、遊戲管理規範： </div>
          <div>為確保遊戲進行之秩序，乙方得訂立合理公平之遊戲管理規範或遊戲規則，甲方應遵守乙方公告之遊戲管理規範或遊戲規則。 </div>
          <div>遊戲管理規範或遊戲規則視為本合約之一部份，與本合約具有相同效力。 </div>
          <div>遊戲管理規範之變更應依第三十一條之程序為之。 </div>
          <div>遊戲管理規範有下列情形之一者，其規定無效：</div>
          <div>抵觸本合約之規定。 </div>
          <div>剝奪或限制甲方之合約上權利。但乙方依本合約第二十六條之規定處理者，不在此限。</div>
          <div>二十三、違反遊戲管理規範/服務合約之處理： </div>
          <div>除遊戲規定及本合約規定外，有事實足證甲方於本遊戲中違反遊戲管理規範或服務合約時，乙方應於遊戲網站或遊戲進行中公告甲方【仕治整合官網】會員帳號，並以線上即時通訊方式或電子郵件通知甲方。經乙方通知改善而未改善者，乙方得依遊戲管理規範，按其情節輕重限制甲方之遊戲使用權利。 </div>
          <div>二十四、免費遊戲 ： </div>
          <div>若乙方提供免費遊戲使用本服務，甲方應自行負擔網際網路連線費用及配備上網所需之費用。</div>
          <div>甲方一經儲值取得虛擬遊戲幣後，視為已使用並確認消費，乙方亦無法進行復原或退費。</div>
          <div>二十五、送達 ：</div>
          <div>有關本合約所有事項之通知，甲方同意乙方以甲方登錄的電子郵件地址或官網公告為送達。 </div>
          <div>前項電子郵件地址變更，甲方應即通知乙方，並同意改依變更後之電子郵件地址為送達。 </div>
          <div>乙方依本條電子郵件地址所為之通知發出後，經通常之傳遞期間，即推定為已送達。因甲方之故意或過失致乙方無法為送達者，乙方對甲方因無法送達所致之損害不負賠償責任。</div>
          <div>二十六、信用卡使用安全之維護：</div>
          <div>(1)	第一次刷卡：</div>
          <div>乙方會針對所有第一次至乙方網站使用的信用卡資料與銀行進行持卡人資料認證的動作。當甲方所使用的信用卡持卡人資料經銀行驗證有問題時，乙方將先行取消甲方的交易並將儲值點數清除，同時請客服人員與甲方聯繫，進行交易確認的動作。不論任何原因，當乙方客戶服務人員無法與您取得聯繫時，將先暫時終止您繼續使用信用卡儲值的服務功能。</div>
          <div>(2)	信用卡盜刷或取消交易：</div>
          <div>當甲方的會員帳號發生信用卡盜刷或取消交易的狀況時，乙方將凍結甲方的會員與遊戲帳號使用權，同時請客戶服務人員與甲方聯繫。若取得聯繫後，甲方無法提供付款憑證證明，乙方會要求甲方先繳付積欠未繳的款項後，方得繼續使用本服務。一經拒絕，乙方即將帳號所有人資料及信用卡刷卡消費記錄比對彙整，送請檢、警單位偵辦，並追究民、刑事之相關責任。若客戶服務人員無法與甲方取得聯繫，事件發生七日內甲方也沒有向客服中心提出異議，則視同甲方同意本公司採取之處理措施。</div>
          <div>(3)	信用卡資料保護：</div>
          <div>請勿在公共場所(如網咖、機場或任何可上網的公共機器)使用信用卡線上刷卡儲值服務，以防止有心人利用木馬程式或鍵盤記錄程式或瀏覽器程式漏洞，竊取您的信用卡相關資料。</div>
          <div>(4)	甲方在使用信用卡線上刷卡儲值的時候，一旦上線點選使用後，即表示甲方已經確認進行「信用卡線上刷卡儲值服務」；儲值入甲方所選擇之帳號的點數，乙方將無法轉讓給第三人 ( 包括同一人擁有多組帳號之情形 ) ，亦無法進行點數回復或退費等動作。</div>
          <div>二十七、ATM轉帳繳費之正確無誤之確認：</div>
          <div>（1）	甲方在使用ATM轉帳繳費的時候，請確認自己的繳費帳號資料正確無誤，同時儘量避免輸入錯誤，轉帳至其他人的會員帳號。依據金融機構的作業處理規定，當甲方轉帳繳費帳號輸入錯誤，以至於款項匯入他人銀行帳戶內時，銀行與商家均不負擔追回或賠償的責任，需要甲方自行與對方聯繫並追回該筆金錢。乙方僅將依法配合檢、警單位或法院的作業提供相關佐證資料協助辦理。再次提醒您，乙方所核發給甲方的轉帳帳號是唯一且無連號情形，所以請務必小心操作。</div>
          <div>（2）	甲方在使用ATM轉帳繳費的時候，一旦上線點選使用後，即表示甲方已經確認進行「 ATM 轉帳付費儲值服務」；儲值入甲方所選擇之帳號的點數，乙方將無法轉讓給第三人 ( 包括同一人擁有多組帳號之情形 ) ，亦無法進行點數回復或退費等動作。</div>
          <div>二十八、合約之變更：</div>
          <div>乙方保留隨時修改本合約或相關規範、遊戲規則之權利，並在未來如有任何修改時，乙方將於遊戲網站首頁及各遊戲首頁公告之，並以書面或電子郵件或公告方式通知甲方。 </div>
          <div>乙方未依前項規進行公告及公告通知者，其合約之變更無效。 </div>
          <div>甲方於第一項通知到達後十五日內：</div>
          <div>如甲方未為反對之表示並繼續使用本服務，則視為甲方已同意並接受乙方合約變更之內容。 </div>
          <div>甲方為反對之表示者，視為甲方對乙方終止本合約之通知。</div>
          <div>二十九、乙方保留權利：</div>
          <div>乙方保有增加、更新或停止本服務之任一手機遊戲營運之權利，並依第三十一條合約之變更方式通知甲方，甲方不得因此而要求任何補償或賠償。</div>
          <div>三十、個別條款之效力：</div>
          <div>本同意書所定之任何甲方條款之全部或一部無效時，不影響其他條款之效力。</div>
          <div>三十一、準據法與管轄法院：</div>
          <div>本合約與相關遊戲管理規範、遊戲規則之解釋及適用、以及甲方因使用本服務而與乙方間所生之權利義務關係，雙方同意以中華民國法律為準據法。 </div>
          <div>因本合約所生糾紛，若有訴訟必要，雙方合意以台灣板橋地方法院為第一審管轄法院。</div>
          <div>前項約定不排除消費者保護法第四十七條或民事訴訟法第四三六條之九小額訴訟管轄法院之適用。</div>
          <div>三十二、宣導事項：</div>
          <div>長時間進行遊戲有害身心健康，請注意手機遊戲僅供娛樂，適度可以抒解壓力，達到娛樂效果，但過度沉迷，則可能影響您現實的生活。</div>
          <div>三十三、資訊公開：</div>
          <div>乙方應於遊戲網站上提供本遊戲相關資訊，並定期更新。</div>
        </div>  
      </div>
      <div class='foot'>
        <img src="@/assets/images/index/footBg.jpg" class="bg">
        <img src="@/assets/images/index/footLogoLeft.png" class="logoLeft">
        <img src="@/assets/images/index/footLogoRight.png" class="logoRight">
        <div class='article' @click="$router.push('/article')"></div>
        <!-- <div class='article1' @click="$router.push('/article1')"></div> -->
        <div class='article2' @click="$router.push('/article2')"></div>
        <div class='article3' @click="goPage('https://www.facebook.com/FairyTownCindeBella')"></div>
      </div>
    </vuescroll>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
export default {
  name: 'index',
  components:{
    vuescroll
  },
  data () {
    return {
      vuescrollOption:{
        scrollPanel: {
          initialScrollY: 6.7*parseFloat(document.documentElement.style.fontSize),
        },
      }
    }
  },
  mounted(){
  },
  methods:{
    goPage(href){
      window.location.href=href;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@fullWidth:19.2rem;

@bannerHeight:872/100rem;
@contectHeight:2162/100rem;
@footHeight:174/100rem;

@googleBTWidth:326/100rem;
@iphoneBTWidth:262/100rem;
@downloadGaps:.5rem;

@newWidth:48/100rem;

@marqueImgWidth:1200/100rem;
.index{
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  overflow: hidden;
  .banner{
    position: relative;
    width: @fullWidth;
    height: @bannerHeight;
    .bg{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 0;
    }
    .downloadBT{
      position: absolute;
      width: @googleBTWidth + @iphoneBTWidth + @downloadGaps;
      left: (@fullWidth - (@googleBTWidth + @iphoneBTWidth + @downloadGaps))/2;
      top: 5.7rem;
      .googleBT{
        position: absolute;
        width: @googleBTWidth;
        right: 0;
        top: 0;
      }
      .iphoneBT{
        position: absolute;
        width: @iphoneBTWidth;
        left: 0;
        top: 0;
      }
    }
  }
  .content{
    margin-left: 3.2rem;
    width: @fullWidth - 6.4rem;
    .breadcrumb{
      margin-top: .35rem;
      margin-bottom: .74rem;
      height:.42rem;
      .left{
        float: left;
        line-height:.42rem;
        font-size:.24rem
      }
      .right{
        float: right;
        font-size:0rem;
        img{
          width:1.32rem;
        }
      }
      a{
        color:#f56b85;
      }
    }
    .titleDiv{
      width:100%;
      height:1.66rem;
      border-top:solid .02rem #ebebeb;
      border-bottom:solid .02rem #ebebeb;
      .title{
        width:100%;
        height:.36rem;
        line-height:.36rem;
        font-size:.36rem;
        color:#ec4828;
        text-align: center;
        margin-top:.5rem;
      }
      .time{
        width:100%;
        height:.24rem;
        line-height:.24rem;
        font-size:.24rem;
        color:#68696b;
        text-align: center;
        margin-top:.18rem;
      }
    }
    .contentText{
      width:@fullWidth - 6.4rem - 2rem;
      line-height:.3rem;
      font-size:.24rem;
      color:#68696b;
      margin-left: 1rem;
      margin-top: .8rem;
      margin-bottom: .8rem;
    }
  }
  .foot{
    position: relative;
    width: @fullWidth;
    height: @footHeight;
    .article{
      position: absolute;
      width: .6rem;
      height:.3rem;
      left:11.4rem;
      top:1.1rem;
      cursor:pointer;
      // background:red;
    }
    .article1{
      position: absolute;
      width: .85rem;
      height:.3rem;
      left:12.2rem;
      top:1.1rem;
      cursor:pointer;
      // background:blue;
    }
    .article2{
      position: absolute;
      width: .85rem;
      height:.3rem;
      left:13.17rem;
      top:1.1rem;
      cursor:pointer;
      // background:yellow;
    }
    .article3{
      position: absolute;
      width: .85rem;
      height:.3rem;
      left:14.2rem;
      top:1.1rem;
      cursor:pointer;
      // background:green;
    }
    .bg{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 0;
    }
    .logoLeft{
      position: absolute;
      width: 3.38rem;
      left: 3.2rem;
      top: .17rem;
    }
    .logoRight{
      position: absolute;
      width: 5.4rem;
      right: 3.2rem;
      top: .17rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/article1.vue